import { QuestionAnswerMap } from '@care-portals/api-interfaces';

/** Shared terminal screens: complete / ineligible / did not consent. */
const genericTerminalQuestions = [
  {
    class: 'ineligible',
    field: 'generic_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    extras: { sendToBeluga: false },
    answer: {},
    type: 'info',
    isLast: true,
    blockQuestionFlow: true
  },
  {
    class: 'ineligible',
    field: 'generic_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    isLast: true,
    reject: true,
    answer: {},
    extras: { sendToBeluga: false }
  },
  {
    field: 'generic_complete',
    isLast: true,
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  }
] as const;

export type GenericTerminalQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof genericTerminalQuestions>
>;

export default genericTerminalQuestions;
